import Error from "../utils/Error.js";
import global from "../global.js";

const log = global.log.getLogger("f_mtac.server.superadministration");
log.setLevel(log.levels.WARN);

let SuperAdministration = function (server) {
    this.authenticated = false;

    this.login = ({passphrase}) => {
        return server
            .post(
                "/superadmin/login",
                {passphrase},
                {
                    401: (error) => {
                        throw new Error.build.access({
                            message: "failed to login",
                            data: {error}
                        });
                    }
                }
            )
            .then((response) => {
                this.authenticated = true;
                return response.json();
            });
    };

    /*this.authenticate = ({passphrase}) => {
        return server.post("/admin/auth", {passphrase}, {
            401: (error) => {
                throw new Error.build.access({
                    message: "failed to authenticate",
                    data: {error}
                });
            }
        }).then(response => {
            this.authenticated = true;
            return response.json();
        });
    };*/

    this.logout = () => {
        return server
            .post(
                "/superadmin/logout",
                {},
                {
                    401: (error) => {
                        throw new Error.build.access({
                            message: "failed to logout",
                            data: {error}
                        });
                    }
                }
            )
            .then((response) => {
                this.authenticated = false;
                return response.json();
            });
    };

    this.create_organization = (name, quota) => {
        return server
            .post(
                "/superadmin/organization",
                {org_name: name, org_quota: quota},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => {
                return response.json();
            });
    };

    this.update_organization = ({org_id, org_name}) => {
        return server
            .post(
                "/superadmin/organization",
                {org_id, org_name},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => {
                return response.json();
            });
    };

    this.delete_organization = ({org_id}) => {
        return server
            .delete(
                "/superadmin/organization",
                {org_id},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => {
                return response.json();
            });
    };

    this.delete_organization_users = ({org_id}) => {
        return server
            .delete(
                "/superadmin/users",
                {org_id},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => {
                return response.json();
            });
    };

    this.org_list = () => {
        return server
            .get(
                "/admin/organization",
                {},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => response.json());
    };

    this.superadmin_passphrase = ({old_password, new_password}) => {
        return server
            .post(
                "/superadmin/passphrase",
                {old_password, new_password},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => response.json());
    };

    this.admin_passphrase_reset = ({org_id, org_name}) => {
        return server
            .post(
                "/superadmin/resetpassphrase",
                {org_id, org_name},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => response.json());
    };

    this.superadmin_export = () => {
        return server
            .get(
                "/superadmin/export",
                {},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => response.blob());
    };

    this.superadmin_import = ({import_data}) => {
        return server
            .upload(
                "/superadmin/import",
                {import_data},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => response.json());
    };

    /**
     * @brief request server to set organization quotas
     * @param {*} body example: [{ "org-id": "505050", "org-max-users": 50 }, ...}
     * @returns
     */
    this.set_organization_quotas = (body) => {
        /* body example 
        log.error("remove test lines below");
        body=[
            { "org-id": "123456", "org-max-users": 50 },
            { "org-id": "303030", "org-max-users": 30 },
        ];*/
        return server
            .post_json("/superadmin/organization/quota", body, {
                401: () => {
                    // reload the page to display the superadmin login page
                    window.document.location.reload();
                }
        })
            .then((response) => response.blob());
    };

    this.get_organization_quotas = () => {
        return server
            .get(
                "/superadmin/organization/quota",
                {},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => response.json());
    };

    this.load_org_file = ({media_data, media_name, org_id}) => {
        log.debug("org_id ", org_id);
        return server
            .upload(
                "/superadmin/organization/file",
                {org_id, media_name, media_data},
                {
                    401: () => {
                        // reload the page to display the superadmin login page
                        window.document.location.reload();
                    }
                }
            )
            .then((response) => response.json());
    };
};
export default SuperAdministration;
